const toggleButton = document.querySelector(".tags-cloud-button");
const dropdownMenu = document.querySelector(".tags-cloud-list");
const iconOpen = toggleButton.querySelector(".icon-open");
const iconClose = toggleButton.querySelector(".icon-close");

const calculateHeight = () => {
  const container = document.querySelector(".tags-cloud-list");
  const items = document.querySelectorAll(".tags-cloud-item");

  const rowHeight = 50;
  const maxRowsDesktop = 3;
  const maxRowsMobile = 5;

  const itemsPerRow = Math.floor(container.offsetWidth / items[0].offsetWidth);
  const rowsCount = Math.ceil(items.length / itemsPerRow);

  let newHeight = 0;

  if (window.innerWidth >= 990) {
    newHeight = Math.min(rowsCount, maxRowsDesktop) * rowHeight;
  } else {
    newHeight = Math.min(rowsCount, maxRowsMobile) * rowHeight;
  }

  container.style.height = `${newHeight}px`;
};

toggleButton.addEventListener("click", (e) => {
  e.stopPropagation();

  e.preventDefault();

  dropdownMenu.classList.toggle("expanded-mobile");
  toggleButton.classList.toggle("active");

  if (dropdownMenu.classList.contains("expanded-mobile")) {
    iconOpen.style.display = "none";
    iconClose.style.display = "block";
    calculateHeight();

    toggleButton.blur(); 
  } else {
    iconOpen.style.display = "block";
    iconClose.style.display = "none";
    dropdownMenu.style.height = "50px";
  }
});

document.addEventListener("click", () => {
  dropdownMenu.classList.remove("expanded-mobile");
  toggleButton.classList.remove("active");
  iconOpen.style.display = "block";
  iconClose.style.display = "none";
});

dropdownMenu.addEventListener("click", (e) => {
  e.stopPropagation();
});
